export interface IPlanTargetingCriterionValueApi {
  plantargetingcriterionvalue_id?: number;
  plantargetingcriterion_id?: number;
  code: string;
  value: string;
}

export interface IPlanTargetingCriterionApi {
  targetingcriterion_id: number;
  plan_id: number;
  plantargetingcriterion_id: number;
  plantargetingcriterion_values: IPlanTargetingCriterionValueApi[];
}

export default class PlanTargetingCriterion {
  planId: number;

  targetingCriterionID: number;

  values: IPlanTargetingCriterionValueApi[];

  constructor(
    id: number,
    planId: number,
    targetingCriterionId: number,
    values: IPlanTargetingCriterionValueApi[] = [],
  ) {
    this.id = id;
    this.planId = planId;
    this.targetingCriterionID = targetingCriterionId;
    this.values = values;
  }

  static fromApi(apiObject: IPlanTargetingCriterionApi): PlanTargetingCriterion {
    return new PlanTargetingCriterion(
      apiObject.plantargetingcriterion_id,
      apiObject.plan_id,
      apiObject.targetingcriterion_id,
      apiObject.plantargetingcriterion_values,
    );
  }

  toApi(): IPlanTargetingCriterionApi {
    return {
      plan_id: this.planId,
      targetingcriterion_id: this.targetingCriterionID,
      plantargetingcriterion_values: this.values,
      plantargetingcriterion_id: this.id,
    };
  }
}
